module.exports = __webpack_public_path__ + "static/plx_logo-e408cae1b9303ee2eb3cfce8f0a612ac.png";